/* OQOVO theme JS — mobile menu + hero video autoplay enforcement */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var burger = document.querySelector('[data-oq-burger]');
    var menu = document.querySelector('[data-oq-mobile-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        menu.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
      });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { menu.classList.remove('is-open'); });
      });
    }

    // Wishlist badge — counts localStorage oq-wish-* keys; repaints after any heart click.
    function oqWishCount() {
      var n = 0;
      try { for (var i = 0; i < localStorage.length; i++) { if (localStorage.key(i).indexOf('oq-wish-') === 0) n++; } } catch (e) {}
      return n;
    }
    function oqPaintWish() {
      var n = oqWishCount();
      document.querySelectorAll('[data-oq-wish-count]').forEach(function (el) { el.textContent = n; });
    }
    oqPaintWish();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-oq-wish]')) setTimeout(oqPaintWish, 80);
    });
    window.addEventListener('storage', oqPaintWish);

    // Browser autoplay policies need muted set as a property before play().
    var startVid = function () {
      var v = document.getElementById('oq-hero-video');
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true;
      if (!v.dataset.oqBound) {
        v.dataset.oqBound = '1';
        ['loadeddata', 'canplay'].forEach(function (ev) {
          v.addEventListener(ev, function () {
            v.muted = true;
            var q = v.play();
            if (q && q.catch) q.catch(function () {});
          });
        });
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    startVid();
    [150, 600, 1500, 3000].forEach(function (t) { setTimeout(startVid, t); });
  });
})();

/* OQOVO cart drawer — Arte replica: AJAX add/edit, grey bands, CTL rail,
   discount, and card hover quick-add ([data-oq-qa-id] size buttons). */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var root = document.querySelector('[data-oq-drawer]');
    if (!root || !window.fetch) return;

    var FS = parseInt(root.getAttribute('data-oq-fs'), 10) || 0;
    var panel = root.querySelector('.oq-drawer__panel');
    var itemsEl = root.querySelector('[data-oq-drawer-items]');
    var emptyEl = root.querySelector('[data-oq-drawer-empty]');
    var bandsEl = root.querySelector('[data-oq-drawer-bands]');
    var countWrap = root.querySelector('[data-oq-drawer-countwrap]');
    var footEl = root.querySelector('[data-oq-drawer-foot]');
    var countEl = root.querySelector('[data-oq-drawer-count]');
    var subEl = root.querySelector('[data-oq-drawer-subtotal]');
    var totalEl = root.querySelector('[data-oq-drawer-total]');
    var errEl = root.querySelector('[data-oq-drawer-error]');
    var shipMsg = root.querySelector('[data-oq-drawer-ship-msg]');
    var closeBtn = root.querySelector('.oq-drawer__close');
    var ctlEl = root.querySelector('[data-oq-drawer-ctl]');
    var ctlTrack = root.querySelector('[data-oq-drawer-ctl-track]');
    var lastFocus = null;
    var busy = false;
    var ctlProducts = null; // cached catalog; rail re-filtered on every open
    var qsPicks = [];
    var qsVariant = null;
    var lastCurrency = 'USD';
    var cartHandles = [];
    var onCartPage = /\/cart\/?$/.test(location.pathname);

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function safeUrl(u) {
      u = String(u == null ? '' : u);
      return /^(\/(?!\/)|https:\/\/)/.test(u) ? u : '#';
    }
    function attrUrl(u) { return esc(safeUrl(u)); }
    function money(cents, currency) {
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }
    function imgUrl(u, w) {
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 320);
    }
    // Shopify throttle/challenge pages answer with HTML — never surface a JSON parse error.
    function errFrom(r, fallback) {
      return r.json()
        .catch(function () { throw new Error(fallback); })
        .then(function (j) { throw new Error(j.description || j.message || fallback); });
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('oq-lock');
      if (closeBtn) closeBtn.focus();
      renderCtl();
    }
    function closeDrawer() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('oq-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
    function clearError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }

    function metaLines(it) {
      var lines = [];
      (it.options_with_values || []).forEach(function (o) {
        if (!o || !o.value || o.value === 'Default Title') return;
        lines.push(/size/i.test(o.name) ? 'Size: ' + o.value : o.value);
      });
      return lines;
    }

    function render(cart) {
      var n = cart.item_count;
      lastCurrency = cart.currency || lastCurrency;
      cartHandles = cart.items.map(function (it) { return it.handle; });
      if (countEl) countEl.textContent = n;
      document.querySelectorAll('[data-oq-cart-count]').forEach(function (el) { el.textContent = n; });
      if (subEl) subEl.textContent = money(cart.total_price, cart.currency);
      if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
      var isEmpty = n === 0;
      if (emptyEl) emptyEl.hidden = !isEmpty;
      if (bandsEl) bandsEl.hidden = isEmpty;
      if (countWrap) countWrap.hidden = isEmpty;
      if (footEl) footEl.hidden = isEmpty;

      if (shipMsg && FS > 0) {
        shipMsg.textContent = cart.total_price >= FS
          ? 'Free shipping & returns on this order'
          : 'Free returns — ' + money(FS - cart.total_price, cart.currency) + ' to free shipping';
      }

      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = (it.featured_image && it.featured_image.url) || it.image;
        var meta = metaLines(it).map(function (l) { return '<span>' + esc(l) + '</span>'; }).join('');
        return '<div class="oq-drawer__item" data-key="' + esc(it.key) + '">' +
          '<a class="oq-drawer__media" href="' + attrUrl(it.url) + '">' +
            (img ? '<img src="' + attrUrl(imgUrl(img)) + '" alt="' + esc(it.product_title) + '" width="134" height="201" loading="eager">' : '') +
          '</a>' +
          '<div class="oq-drawer__info">' +
            '<a class="oq-drawer__name" href="' + attrUrl(it.url) + '">' + esc(it.product_title) + '</a>' +
            '<div class="oq-drawer__meta">' + meta +
              '<span class="oq-drawer__iprice">' + money(it.final_price, cart.currency) + '</span>' +
            '</div>' +
            '<div class="oq-drawer__row">' +
              '<span class="oq-drawer__qty">' +
                '<button type="button" class="oq-drawer__step" data-oq-drawer-qty="' + (it.quantity - 1) + '"' + (it.quantity <= 1 ? ' disabled' : '') + ' aria-label="Decrease quantity of ' + esc(it.product_title) + '">' +
                  '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true" focusable="false"><path d="M4 12h16"/></svg>' +
                '</button>' +
                '<span class="oq-drawer__qtyn">' + it.quantity + '</span>' +
                '<button type="button" class="oq-drawer__step" data-oq-drawer-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity of ' + esc(it.product_title) + '">' +
                  '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true" focusable="false"><path d="M12 4v16M4 12h16"/></svg>' +
                '</button>' +
              '</span>' +
              '<button type="button" class="oq-drawer__remove" data-oq-drawer-qty="0">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    function getCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }
    function refresh() { return getCart().then(render); }

    /* Complete your look — catalog cached once, re-filtered against the cart on every open. */
    function renderCtl() {
      if (!ctlEl || !ctlTrack) return;
      if (!ctlProducts) {
        fetch('/collections/all/products.json?limit=12', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            ctlProducts = (data.products || []).filter(function (p) { return p.images && p.images.length; });
            renderCtl();
          })
          .catch(function () { /* rail simply stays hidden */ });
        return;
      }
      var picks = ctlProducts.filter(function (p) { return cartHandles.indexOf(p.handle) === -1; }).slice(0, 8);
      if (!picks.length) { ctlEl.hidden = true; return; }
      qsPicks = picks;
      ctlTrack.innerHTML = picks.map(function (p, i) {
        return '<div class="oq-drawer__ctl-item">' +
          '<a href="' + attrUrl('/products/' + p.handle) + '" aria-label="' + esc(p.title) + '">' +
            '<img src="' + attrUrl(imgUrl(p.images[0].src, 240)) + '" alt="' + esc(p.title) + '" width="106" height="133" loading="eager">' +
          '</a>' +
          ((p.variants || []).length ? '<button type="button" class="oq-drawer__ctl-add" data-oq-ctl-plus="' + i + '" aria-label="Quick add ' + esc(p.title) + '">' +
            '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true" focusable="false"><path d="M12 4v16M4 12h16"/></svg>' +
          '</button>' : '') +
        '</div>';
      }).join('');
      ctlEl.hidden = false;
    }
    root.querySelectorAll('[data-oq-ctl-prev],[data-oq-ctl-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        ctlTrack.scrollBy({ left: btn.hasAttribute('data-oq-ctl-next') ? 342 : -342, behavior: 'smooth' });
      });
    });
    /* Quick-shop view (Arte): "+" opens an in-drawer product view with photos + sizes. */
    var qsEl = root.querySelector('[data-oq-qs]');
    var qsName = root.querySelector('[data-oq-qs-name]');
    var qsLink = root.querySelector('[data-oq-qs-link]');
    var qsImgs = root.querySelector('[data-oq-qs-imgs]');
    var qsSizes = root.querySelector('[data-oq-qs-sizes]');
    var qsAtc = root.querySelector('[data-oq-qs-atc]');
    var qsPrice = root.querySelector('[data-oq-qs-price]');
    var qsCta = root.querySelector('[data-oq-qs-cta]');

    function prodMoney(v) {
      var cents = Math.round(parseFloat(v.price) * 100);
      return isNaN(cents) ? '' : money(cents, lastCurrency);
    }
    function openQs(p) {
      qsVariant = null;
      qsName.textContent = p.title;
      qsLink.href = safeUrl('/products/' + p.handle);
      var imgs = (p.images || []).slice(0, 2);
      qsImgs.classList.toggle('is-single', imgs.length < 2);
      qsImgs.innerHTML = imgs.map(function (im) {
        return '<img src="' + attrUrl(imgUrl(im.src, 600)) + '" alt="' + esc(p.title) + '" loading="eager">';
      }).join('');
      qsSizes.innerHTML = (p.variants || []).map(function (v, i) {
        return '<button type="button" class="oq-drawer__qs-size" data-oq-qs-v="' + i + '"' + (v.available === false ? ' disabled' : '') + ' role="option" aria-selected="false">' + esc(v.title) + '</button>';
      }).join('');
      qsSizes.__variants = p.variants || [];
      qsPrice.textContent = prodMoney((p.variants || [])[0] || {});
      qsCta.textContent = 'Select a size';
      qsAtc.setAttribute('data-ready', 'false');
      qsEl.hidden = false;
      var back = qsEl.querySelector('[data-oq-qs-close]');
      if (back) back.focus();
    }
    function closeQs() {
      qsEl.hidden = true;
      qsVariant = null;
      if (closeBtn) closeBtn.focus();
    }
    if (ctlTrack) {
      ctlTrack.addEventListener('click', function (e) {
        var plus = e.target.closest('[data-oq-ctl-plus]');
        if (!plus) return;
        e.preventDefault();
        var p = qsPicks[parseInt(plus.getAttribute('data-oq-ctl-plus'), 10)];
        if (p) openQs(p);
      });
    }
    if (qsEl) {
      qsEl.querySelector('[data-oq-qs-close]').addEventListener('click', closeQs);
      qsSizes.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-oq-qs-v]');
        if (!btn || btn.disabled) return;
        qsSizes.querySelectorAll('.oq-drawer__qs-size').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-selected', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-selected', 'true');
        qsVariant = qsSizes.__variants[parseInt(btn.getAttribute('data-oq-qs-v'), 10)];
        qsPrice.textContent = prodMoney(qsVariant);
        qsCta.textContent = 'Add to cart';
        qsAtc.setAttribute('data-ready', 'true');
      });
      qsAtc.addEventListener('click', function () {
        if (!qsVariant) return;
        addToCart({ id: qsVariant.id, quantity: 1 }, false).then(closeQs);
      });
    }

        /* Discount code — /discount/ only stores the code (validated at checkout); say so honestly. */
    var discToggle = root.querySelector('[data-oq-discount-toggle]');
    var discForm = root.querySelector('[data-oq-discount-form]');
    var discOk = root.querySelector('[data-oq-discount-ok]');
    var discChange = root.querySelector('[data-oq-discount-change]');
    if (discToggle && discForm) {
      discToggle.addEventListener('click', function () {
        discForm.hidden = false;
        discToggle.hidden = true;
        discToggle.setAttribute('aria-expanded', 'true');
        discForm.querySelector('input').focus();
      });
      discForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = discForm.querySelector('input').value.trim();
        if (!code) return;
        fetch('/discount/' + encodeURIComponent(code))
          .then(function (r) {
            if (!r.ok) throw new Error('bad');
            discForm.hidden = true;
            if (discOk) discOk.hidden = false;
          })
          .catch(function () { showError('Could not save the code — try again.'); });
      });
      if (discChange) {
        discChange.addEventListener('click', function () {
          discOk.hidden = true;
          discForm.hidden = false;
          discForm.querySelector('input').focus();
        });
      }
    }

    function addToCart(body, isFormData) {
      if (busy) return Promise.resolve();
      busy = true;
      clearError();
      var opts = isFormData
        ? { method: 'POST', body: body, headers: { 'Accept': 'application/json' } }
        : { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
      return fetch('/cart/add.js', opts)
        .then(function (r) {
          if (!r.ok) return errFrom(r, 'Could not add to cart.');
          return refresh();
        })
        .then(function () { openDrawer(); })
        .catch(function (err) { showError(err.message || 'Could not add to cart.'); openDrawer(); })
        .then(function () { busy = false; });
    }

    /* Intercept every add-to-cart form (PDP main + sticky bar share one form). */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      addToCart(new FormData(form), true);
    });

    /* Card hover quick-add: size buttons inside product-card links. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oq-qa-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      addToCart({ id: parseInt(btn.getAttribute('data-oq-qa-id'), 10), quantity: 1 }, false);
    }, true);

    /* Header cart link opens the drawer — except on the cart page itself,
       where a second, drawer-only cart UI would go stale behind it. */
    if (!onCartPage) {
      document.querySelectorAll('[data-oq-cart-link]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey) return;
          e.preventDefault();
          clearError();
          refresh().then(openDrawer).catch(function () { window.location.href = a.href; });
        });
      });
    }

    /* Quantity steppers + remove, delegated. */
    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oq-drawer-qty]');
      if (!btn || btn.disabled || busy) return;
      var line = btn.closest('[data-key]');
      var qty = parseInt(btn.getAttribute('data-oq-drawer-qty'), 10);
      if (!line || isNaN(qty) || qty < 0) return;
      busy = true;
      clearError();
      line.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) return errFrom(r, 'Could not update the cart.');
          return r.json().then(render);
        })
        .then(function () { renderCtl(); })
        .catch(function (err) { showError(err.message || 'Could not update the cart.'); line.classList.remove('is-busy'); })
        .then(function () { busy = false; });
    });

    /* Close: X, click-catcher, empty-state CTA, Escape. */
    root.querySelectorAll('[data-oq-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.tagName === 'A') return closeDrawer(); // let the link navigate too
        e.preventDefault();
        closeDrawer();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      if (qsEl && !qsEl.hidden) closeQs();
      else closeDrawer();
    });

    /* Keep focus inside the dialog while open. */
    document.addEventListener('focusin', function (e) {
      if (root.classList.contains('is-open') && !panel.contains(e.target)) {
        if (closeBtn) closeBtn.focus();
      }
    });

    /* Public hook for other sections (e.g. "The Set" — add multiple variants at once). */
    window.oqDrawer = {
      open: function () { refresh().then(openDrawer); },
      addItems: function (items) { return addToCart({ items: items }, false); },
    };

    /* First paint if the page loaded with items (drawer opens later with fresh data anyway). */
    if (parseInt(countEl && countEl.textContent, 10) > 0) refresh();
  });
})();
